import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/pro-solid-svg-icons';
import { useState } from 'react';
import styles from './fare-districts-accordion.module.scss';
import { FareDistrictsList } from '../fare-districts-list/fare-districts-list';
import type { District, FareType } from '../../types';

interface FareDistrictsAccordionProps {
  cityName: string;
  cityId: string;
  districts: District[];
  fareType: FareType;
}

export const FareDistrictsAccordion = ({
  cityName,
  cityId,
  districts,
  fareType,
}: FareDistrictsAccordionProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={styles.accordionContainer}>
      <div
        className={`${styles.container} 
        ${isOpen ? styles.openedContainer : ''}
      `}
      >
        <button type="button" onClick={() => setIsOpen(!isOpen)}>
          <span>{cityName.toUpperCase()}</span>
          <FontAwesomeIcon icon={isOpen ? faChevronUp : faChevronDown} />
        </button>
      </div>
      {isOpen && (
        <FareDistrictsList
          fareType={fareType}
          districts={districts}
          isOnAccordion
          cityId={cityId}
        />
      )}
    </div>
  );
};
